// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import OwlCarousel from "./components/OwlCarousel";
import Flickity from "./components/Flickity";
// import Slick from "./components/Slick";
import Navigation from "./components/Navigation";

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    // OwlCarousel.init();
    Flickity.init();
    // Slick.init();
    Navigation.init();
    ReplaceObfuscatedEmailAddresses.init();
    AnimateOnPageLinks.init();
});